import apolloClient from "app/graphql/apolloClient";
import customerActions from "../../actions";
import commonActions from "../../../common/actions";
import messagesActions from "core/state/redux/data/messages/actions";
import queryActions from "core/state/redux/data/queries/actions";
import { gql } from "graphql.macro";
import { merge } from "lodash";

const SET_SHIPPING_METHODS_ON_CART = gql`
  mutation SetShippingMethodsOnCart($input: SetShippingMethodsOnCartInput) {
    setShippingMethodsOnCart(input: $input) {
      cart {
        id
        # ship_complete
        prices {
          subtotal_including_tax {
            currency
            value
          }
          subtotal_excluding_tax {
            currency
            value
          }
          grand_total {
            currency
            value
          }
          applied_taxes {
            amount {
              currency
              value
            }
            label
          }
          discounts {
            amount {
              currency
              value
            }
            label
          }
        }
        shipping_addresses {
          city
          country {
            code
            label
          }
          firstname
          lastname
          postcode
          street
          telephone
          region {
            code
            label
          }
          available_shipping_methods {
            amount {
              currency
              value
            }
            available
            carrier_code
            carrier_title
            error_message
            method_code
            method_title
            price_excl_tax {
              currency
              value
            }

            price_incl_tax {
              currency
              value
            }
          }
          selected_shipping_method {
            amount {
              currency
              value
            }
            carrier_code
            carrier_title
            method_code
            method_title
          }
        }
      }
    }
  }
`;

export default async (store, action) => {
  try {
    let cart_id = store.getState().customer.data.cartToken;
    let cartInformation = store.getState().customer.data.cart;
    let input = {
      cart_id: cart_id,
      shipping_methods: action.shipping_methods,
    };

    const { data } = await apolloClient.mutate({
      mutation: SET_SHIPPING_METHODS_ON_CART,
      variables: { input: input },
      fetchPolicy: "no-cache",
    });
    if (data.setShippingMethodsOnCart !== null) {
      let newCart = {
        ...cartInformation,
      };
      merge(newCart, data.setShippingMethodsOnCart.cart);
      newCart = {
        ...newCart,
        shipping_addresses: [
          ...data.setShippingMethodsOnCart.cart.shipping_addresses,
        ],
      };
      store.dispatch(customerActions.setCartInformation(newCart));

      store.dispatch(commonActions.unlock("success"));
    }
  } catch (error) {
    if (error.message.includes("Could not find a cart with ID")) {
      store.dispatch(customerActions.createEmptyCart());
    } else {
      store.dispatch(messagesActions.addMessage(error.toString(), "danger"));
    }
    store.dispatch(commonActions.unlock("fail"));
    store.dispatch(queryActions.removeQuery());
    return;
  }
};
